// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconFlag = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path
      fillRule="evenodd"
      d="M5 3.613V2H3v19h2v-5.279l2.422-.807a4.93 4.93 0 014.457.69 6.93 6.93 0 007.392.478L22 14.594V4l-1.479-.878-2.208 1.205a4.93 4.93 0 01-5.258-.341 6.93 6.93 0 00-6.265-.97zM5 5.72v7.892l1.79-.597a6.93 6.93 0 016.265.97 4.93 4.93 0 005.258.34l1.687-.92V5.686l-.729.397a6.93 6.93 0 01-7.392-.479 4.93 4.93 0 00-4.457-.69z"
    />
  );
export default SvgIconFlag;
